import { inject, provide, ref } from 'vue';

const INJECTION_SHOW_TOAST = Symbol('INJECTION_SHOW_TOAST');

export function useToastProvider() {
  const toastMessage = ref('');
  let toastTimeout;

  function showToast(message, duration = 2000) {
    toastMessage.value = message;
    window.clearTimeout(toastTimeout);
    toastTimeout = window.setTimeout(() => {
      toastMessage.value = '';
    }, duration);
  }

  provide(INJECTION_SHOW_TOAST, showToast);

  return { toastMessage };
}

export function useToast() {
  return inject(INJECTION_SHOW_TOAST, () => {});
}
